module.exports = __webpack_public_path__ + "assets/media/lunch.cf3fb3a5.mp3";